import { TenantStatusEnum } from '../../../platform/tenants';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';

/**
 * Tenant metadata DTO for records.
 */
export class TenantMetadataRecordDto extends BaseDto {
  tenantId!: number;
  tenantOrgId!: string;
  tenantName!: string;
  tenantStatus!: TenantStatusEnum;
  enableMetering!: boolean;
  meteringStartsAt?: string | null;
  billingCaptureRules?: Record<string, unknown>[] | null;
  enableNotificationProcessing!: boolean;
  enableReminderProcessing!: boolean;
  enableFileProcessing!: boolean;
  enableProtoProcessing!: boolean;
}
